import { DataGuard } from '@components/DataGuard'
import LayoutHeader from '@components/LayoutHeader'
import Panel from '@components/Panel';
import { usePotentialHighQuality } from '@stateApp'; // Ensure this is exported from your state barrel file
import { For } from 'solid-js'
import { useService } from 'solid-services'
import { Container, Grid } from 'styled-system/jsx'
import { scrollbar } from 'styled-system/recipes'
import Task from './Task'

export default function () {
  const { potentialHighQualityQuery } = useService(usePotentialHighQuality)()

  return (
    <Grid gridTemplateRows='auto 1fr' gap={0}>
      <LayoutHeader title="Potential High Quality" />
      <Panel display='grid' gap={6} height='calc(var(--vh) * 100 - 54px)' overflowY='auto' class={scrollbar()} alignContent='start' gridAutoRows={'max-content'}>
        <Container>
          <DataGuard
            query={potentialHighQualityQuery}
          >
            {(poentialHighQualities) => (
              <For each={poentialHighQualities}>
                {(poentialHighQuality) => <Task poentialHighQuality={poentialHighQuality} />}
              </For>
            )}
          </DataGuard>
        </Container>
      </Panel>
    </Grid>
  )
}
